import type { HiddenIdentity, Player } from '../../types';
import { useAutoConfirm } from '../../hooks/useAutoConfirm';
import styles from './IdentityReveal.module.css';

interface Props {
  identity: HiddenIdentity;
  player: Player;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function IdentityReveal({ identity, player, onConfirm, onCancel }: Props) {
  const { countdown, cancelAutoConfirm } = useAutoConfirm({
    onAutoConfirm: onCancel,
    delayMs: 10000,
    enabled: true,
  });

  const balanceLabels = {
    mild: '温和',
    medium: '中等',
    defensive: '防御',
  };
  const balanceColors = {
    mild: '#4CAF50',
    medium: '#FF9800',
    defensive: '#2196F3',
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.warning}>⚠️ 确认暴露身份？</span>
        </div>

        <div className={styles.identityCard}>
          <span className={styles.identityEmoji}>{identity.emoji}</span>
          <h3 className={styles.identityName}>{identity.name}</h3>
          <span
            className={styles.balanceTag}
            style={{ background: balanceColors[identity.balance] }}
          >
            {balanceLabels[identity.balance]}
          </span>
        </div>

        <div className={styles.effects}>
          <div className={styles.effectRow}>
            <span className={styles.effectLabel}>暴露前</span>
            <span className={styles.effectText}>{identity.beforeRevealDesc}</span>
          </div>
          <div className={styles.divider}>↓ 暴露后 ↓</div>
          <div className={styles.effectRow}>
            <span className={styles.effectLabel}>反转效果</span>
            <span className={styles.effectTextHighlight}>{identity.afterRevealDesc}</span>
          </div>
        </div>

        <p className={styles.note}>
          暴露后身份将对所有人可见，反转效果立即触发
        </p>

        <div className={styles.countdown}>⏰ {countdown}s 后自动暂不暴露</div>
        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={() => { cancelAutoConfirm(); onCancel(); }}>
            暂不暴露
          </button>
          <button className={styles.confirmBtn} onClick={() => { cancelAutoConfirm(); onConfirm(); }}>
            <span>🃏</span>
            暴露身份
          </button>
        </div>
      </div>
    </div>
  );
}
